import { SmartLink } from '../../../../app/[locale]/[bookingCode]/_components/smart-link';
import { Mxp365Link } from '../mxp365/Mxp365Link';
import { SurveyLink } from '../survey/SurveyLink';

import type PrismAPI from '@modules/prism-client/types/prism-types';
import type { FC, HTMLAttributes } from 'react';

type Props = HTMLAttributes<HTMLAnchorElement> & {
  data: PrismAPI.LinkElement;
};

export const Link: FC<Props> = ({ data, ...props }) => {
  if (data.type === 'prism') {
    return <SmartLink {...props} href={data.path} />;
  }

  if (data.type === 'mxp365') {
    return <Mxp365Link data={data} {...props} />;
  }

  if (data.type === 'survey') {
    return <SurveyLink data={data} {...props} />;
  }

  // TODO: handle actions elsewhere -> (link.ts)
  if (data.type === 'action') {
    return null;
  }

  return <SmartLink {...props} href={data.url} />;
};
